export const PAGE_LIMIT = 100;
export const PARAMS_NAME = {
    affid: 'Affid',
    subid: 'Subid',
    country: 'Country'
};



// WEBPACK FOOTER //
// ./src/scenes/BidderBids/config.js